module.exports = __webpack_public_path__ + "assets/img/cut2.f5bcdead.png";